export const extractYoutubeId = (url: string): string | null => {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[2].length === 11 ? match[2] : null;
};

export const extractVimeoId = (url: string): string | null => {
  const regExp = /^.*(vimeo\.com\/)(\d+).*/;
  const match = url.match(regExp);
  return match && match[2] ? match[2] : null;
};

export const getVideoType = (
  url: string,
): "youtube" | "vimeo" | "custom" | null => {
  if (!url) return null;

  if (extractYoutubeId(url)) return "youtube";
  if (extractVimeoId(url)) return "vimeo";

  // Check if it's a valid URL for custom video
  try {
    const urlObj = new URL(url);
    if (["http:", "https:"].includes(urlObj.protocol)) {
      return "custom";
    }
  } catch {
    // Invalid URL
  }

  return null;
};
